export default __webpack_public_path__ + "static/media/fd (2).b64e55e4.png";